import { TreeSelect } from 'antd';
import type { BranchFilterProps } from '../reports.types';

const { SHOW_PARENT } = TreeSelect;

const BranchFilter = ({ hasOneStateAccess, oneState, states, selectedState, onChange }: BranchFilterProps) => {
  return (
    <>
      Филиал:
      {hasOneStateAccess && oneState ? (
        <div style={{ marginTop: 7, fontWeight: 500 }}>{oneState.name}</div>
      ) : (
        <TreeSelect
          style={{ marginTop: 7, width: '100%' }}
          treeCheckable={true}
          showCheckedStrategy={SHOW_PARENT}
          treeData={states}
          treeDefaultExpandedKeys={['all']}
          placeholder="Выберите филиал"
          value={selectedState}
          onChange={onChange}
          showSearch
          filterTreeNode={(inputValue, treeNode) => {
            const label = String(treeNode.label ?? '');
            return label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
          }}
        />
      )}
    </>
  );
};

export default BranchFilter;